export const breaklineUtils = {
  props: {
    splitWithDiv: true,
    breaklineClassName: 'py-1',
    tag: 'span',
    color: 'dark',
    lighter: true
  }
}